import { request } from './_request';
import moment from 'moment';

export const getData = () => {
  //console.log('getIndicadores')

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_EO', payload: true });

    let params = getState().evaluacionOptima;

    const user = JSON.parse(localStorage.getItem('@@auth_user'));

    let anio =
      params.fecha == null
        ? moment().format('YYYY')
        : params.fecha.format('YYYY');
    let mes =
      params.fecha == null ? moment().format('MM') : params.fecha.format('MM');
    request
      .get('/evaluacion/indicadores', {
        params: {
          puesto: params.puesto,
          anio: anio,
          mes: mes,
          marca: params.marca,
          unidad: params.unidadNegocio,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        if (response.data.code === 0) {
          console.log(anio, mes);

          let fechaCierre = moment(response.data.result.FechaCierre);

          const fechaValida = moment(fechaCierre).isSameOrAfter(
            moment(),
            'days'
          );

          dispatch({
            type: 'SUCCESS_DATA_EO',
            payload: {
              indicadores: response.data.result.indicadores,
              calificaciones: response.data.result.calificaciones,
              fechaCierre: fechaCierre,
              fechaValida: fechaValida,
              ventasAPV: response.data.result.ventasAPV,
            },
          });
        } else {
          dispatch({
            type: 'ERROR_DATA_EO',
            payload: { message: response.data.error },
          });
        }
      })
      .catch((e) => {
        console.log(e);
        dispatch({ type: 'ERROR_DATA_EO', payload: { message: e.message } });
      });
  };
};

export const getDataAux = () => {
  //console.log('getIndicadores')

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_EO', payload: true });
    let params = getState().evaluacionOptima;

    const user = JSON.parse(localStorage.getItem('@@auth_user'));

    let anio =
      params.fecha == null
        ? moment().format('YYYY')
        : params.fecha.format('YYYY');
    let mes =
      params.fecha == null ? moment().format('MM') : params.fecha.format('MM');

    request
      .get('/evaluacion/indicadores2', {
        params: {
          puesto: params.puesto,
          anio: anio,
          mes: mes,
          marca: params.marca,
          unidad: params.unidadNegocio,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        if (response.data.code === 0) {
          dispatch({
            type: 'SUCCESS_DATA_EO_AUX',
            payload: response.data.result,
          });
        } else {
          dispatch({
            type: 'ERROR_DATA_EO',
            payload: { message: response.data.error },
          });
        }
      })
      .catch((e) => {
        dispatch({ type: 'ERROR_DATA_EO', payload: { message: e.message } });
      });
  };
};

export const changeFilter = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_FILTER_EO',
      payload: { [key]: value },
    });
  };
};

export const resetIndicador = () => {
  return (dispatch, getState) => {
    dispatch({
      type: 'RESET_DATA_INDICADOR',
      payload: true,
    });
  };
};

export const changeIndicadorValue = (col, value, ind) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_DATA_INDICADOR',
      payload: { indicadores: ind },
    });
  };
};

export const saveEvaluacion = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'SAVE_DATA_EO', payload: true });
    let params = getState().evaluacionOptima;

    const user = JSON.parse(localStorage.getItem('@@auth_user'));
    let indAux = params.indicadores;
    let anio =
      params.fecha == null
        ? moment().format('YYYY')
        : params.fecha.format('YYYY');
    let mes =
      params.fecha == null ? moment().format('MM') : params.fecha.format('MM');
    let marca = params.marca;
    let unidad = params.unidadNegocio;

    let indicadores = indAux.filter((ob) => ob.Modificado);
    //console.log('Se modificaron: ', modificados.length )
    if (indicadores.length > 0) {
      request
        .post(
          '/evaluacion/save',
          { anio, mes, marca, unidad, indicadores },
          { headers: { Authorization: `Bearer ${user.token}` } }
        )
        .then((response) => {
          if (response.data.result.code === 0) {
            return dispatch({
              type: 'SAVED_EO',
              payload: response.data.result,
            });
          } else {
            return dispatch({
              type: 'ERROR_SAVED_EO',
              payload: response.data.result,
            });
          }
        });
    }
  };
};

export const getPuestos = (val) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_PUESTOS', payload: true });
    request
      .get('/evaluacion/puestos', {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        dispatch({ type: 'SUCCESS_PUESTOS_EO', payload: response.data.result });
      });
  };
};

export const getMarcas = () => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_MARCA', payload: true });
    request
      .get('/evaluacion/marcas', {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        dispatch({ type: 'SUCCESS_MARCAS_EO', payload: response.data.result });
      });
  };
};

export const getColumnas = () => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  return (dispatch, getState) => {
    dispatch({ type: 'LOADING_COLUMNAS', payload: true });
    request
      .get('/evaluacion/columnas', {
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        dispatch({
          type: 'SUCCESS_COLUMNAS_EO',
          payload: response.data.result,
        });
      });
  };
};

export const get_ventas_apv = (meta, indicadores, ind) => {
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  console.log('Api', meta, indicadores[ind].Indicador);

  return (dispatch, getState) => {
    dispatch({ type: 'GET_APVS', payload: true });
    let params = getState().evaluacionOptima;
    let anio =
      params.fecha == null
        ? moment().format('YYYY')
        : params.fecha.format('YYYY');
    let mes =
      params.fecha == null ? moment().format('MM') : params.fecha.format('MM');
    request
      .get('/evaluacion/asesores', {
        params: {
          meta: meta,
          puesto: params.puesto,
          anio: anio,
          mes: mes,
          marca: params.marca,
          unidad: params.unidadNegocio,
        },
        headers: { Authorization: `Bearer ${user.token}` },
      })
      .then((response) => {
        let cantidad = response.data.result.apvCumplen;
        let ob = indicadores[ind].Respuestas[1].Valor;
        indicadores[ind].Respuestas[2].Valor = cantidad;

        let cump = ((cantidad / ob) * 100).toFixed(2);
        indicadores[ind].Respuestas[3].Valor = cump;
        indicadores[ind].Respuestas[3].TipoValor = '%';

        dispatch({
          type: 'CHANGE_DATA_INDICADOR',
          payload: response.data.result,
        });
      });
  };
};
